import React, { ReactNode } from "react";
import { mergeStyleSets } from "@fluentui/react";
import { multiline } from "../../utils/helpers/LanguageHelper";
import HeaderPanel from "./HeaderPanel";

const classNames = mergeStyleSets({
  message: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    width: "100%",
    color: "var(--color-blue)",
    textAlign: "center",
  },
  icon: {
    width: "100%",
    maxWidth: "300px",
    maxHeight: "300px",
    objectFit: "contain",
  },
  iconWrapper: { padding: "0 2rem", display: "flex", width: "100%", justifyContent: "center" },
  container: {
    width: "100%",
    minHeight: "70vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "1rem",
    padding: "1rem",
  },
});

interface OperationCompletedProps {
  message: string;
  icon: string;
  alt: string;
  title?: string;
  children?: ReactNode;
  styles?: {
    message?: React.CSSProperties;
    icon?: React.CSSProperties;
    iconWrapper?: React.CSSProperties;
    container?: React.CSSProperties;
  };
}

export const OperationCompletedPanel = (props: OperationCompletedProps) => {
  const { message, icon, alt, title, children, styles } = props;

  return (
    <>
      {title && <HeaderPanel applyPadding>{title}</HeaderPanel>}
      <div className={classNames.container} style={styles?.container}>
        <div className={classNames.iconWrapper} style={styles?.iconWrapper}>
          <img alt={alt} src={icon} className={classNames.icon} style={styles?.icon} />
        </div>
        <span className={classNames.message} style={styles?.message}>
          {multiline(message)}
        </span>
        {children && (
          <span className={classNames.message} style={styles?.message}>
            {children}
          </span>
        )}
      </div>
    </>
  );
};
